export default __webpack_public_path__ + "ea6b1bb99e30255f65c0c9ff0bccd356.webp";